import React from 'react';
import { MapPin, ShieldCheck, Clock, Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SocialProofProps {
  mode: 'pessoal' | 'empresa';
}

const SocialProof: React.FC<SocialProofProps> = ({ mode }) => {
  const { t } = useTranslation();

  if (mode === 'empresa') {
    const companies = [
      { name: 'AMIVIK Farmácias', logo: '/assets/logos/amivik-farmacia.png' },
      { name: 'FIA MENDES', logo: '/assets/logos/fiaMendes.png' },
      { name: 'Gráfica fiaMendes', logo: '/assets/logos/grafica-fia-mendes.png' },
      { name: 'artesMais', logo: '/assets/logos/artesmais.png' }
    ];

    return (
      <section className="bg-slate-50 py-12 border-b border-gray-200">
        <div className="container mx-auto px-6 text-center">
          <p className="text-xs font-bold text-[#FF6B35] uppercase tracking-widest mb-6 flex items-center justify-center gap-1.5">
            <Building2 size={14} />
            {t('socialProof.companiesTitle')}
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-center max-w-4xl mx-auto">
            {companies.map((c, idx) => (
              <div 
                key={idx} 
                className="flex justify-center items-center py-4 px-6 bg-white rounded-xl shadow-sm border border-gray-100 h-20 hover:shadow-md transition duration-300"
              >
                <img 
                  src={process.env.PUBLIC_URL + c.logo} 
                  alt={c.name} 
                  className="max-h-12 max-w-full object-contain grayscale hover:grayscale-0 transition duration-300" 
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-white py-12 border-b border-gray-100">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Item 1 */}
          <div className="flex items-center justify-center p-6 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow duration-300">
            <div className="p-4 bg-orange-100 rounded-full mr-4">
              <MapPin className="w-8 h-8 text-[#FF6B35]" />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-800">Luanda</h3>
              <p className="text-gray-600 font-medium">
                  {t('common.loading') === 'Loading...' ? 'Total Coverage' : 'Cobertura Total'}
              </p>
            </div>
          </div>

          {/* Item 2 */}
          <div className="flex items-center justify-center p-6 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow duration-300">
            <div className="p-4 bg-green-100 rounded-full mr-4">
              <Clock className="w-8 h-8 text-green-600" />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-800">
                  {t('common.loading') === 'Loading...' ? 'Speed' : 'Rapidez'}
              </h3>
              <p className="text-gray-600 font-medium">
                  {t('common.loading') === 'Loading...' ? 'Beat the Traffic' : 'Evite o Trânsito'}
              </p>
            </div>
          </div>

          {/* Item 3 */}
          <div className="flex items-center justify-center p-6 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow duration-300">
            <div className="p-4 bg-blue-100 rounded-full mr-4">
              <ShieldCheck className="w-8 h-8 text-blue-500 fill-current" />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-800">24/7</h3>
              <p className="text-gray-600 font-medium">
                  {t('common.loading') === 'Loading...' ? 'Available Support' : 'Suporte Disponível'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
